import { useContext } from 'react';

import { IEnrollmentPremiumDto } from '@modules/members/enrollments/common/types';
import { EnrollmentContext } from '@modules/members/enrollments/context/MemberMyEnrollmentProvider';

const useValidateSubsidyAmount = () => {
    const { enableContinueButton, enrollmentPremiumFormContext, selectedEnrollment } = useContext(EnrollmentContext);
    const { setValue } = enrollmentPremiumFormContext;

    return (premiumData: IEnrollmentPremiumDto) => {
        const premium = { ...premiumData };
        enableContinueButton();

        premium.netPremiumAmount = premium.grossPremiumAmount;
        premium.minimumPremium = premium.minimumPremium || 0;
        if (premium.aptcAmount !== undefined && premium.aptcAmount !== null) {
            if (premium.netPremiumAmount - (Number(premium.aptcAmount) || 0) < premium.minimumPremium) {
                premium.aptcAmount = premium.grossPremiumAmount - premium.minimumPremium;
                premium.netPremiumAmount = premium.minimumPremium;
            } else {
                premium.netPremiumAmount = premium.netPremiumAmount - (Number(premium.aptcAmount) || 0);
            }
        }

        if (premium.stateSubsidyAmount !== undefined) {
            premium.netPremiumAmount =
                premium.netPremiumAmount -
                ((Number(premium.stateSubsidyAmount) || 0) + (Number(premium.stateSubsidy2Amount) || 0));
        }

        if (premium.statePremiumCreditAmt !== undefined) {
            if (premium.netPremiumAmount - premium.statePremiumCreditAmt < 0) {
                premium.netPremiumAmount = 0;
            } else {
                premium.netPremiumAmount = premium.netPremiumAmount - premium.statePremiumCreditAmt;
            }
        }

        if (premium?.isMedicaidTransitionEligible) {
            let medicaidTransitionAmount =
                premium.grossPremiumAmount -
                ((Number(premium.aptcAmount) || 0) +
                    (Number(premium.stateSubsidy2Amount) || 0) +
                    (Number(premium.stateSubsidyAmount) || 0) +
                    (Number(premium.maxAptc) || 0) -
                    (Number(premium.aptcAmount) || 0));
            premium.medicaidTransitionAmount = medicaidTransitionAmount < 0 ? 0 : medicaidTransitionAmount;
            setValue(
                `enrollmentPremiumDtoList.${premium.month - 1}.medicaidTransitionAmount`,
                premium.medicaidTransitionAmount,
                {
                    shouldDirty: true,
                    shouldValidate: true,
                },
            );
        }

        premium.netPremiumAmount = Number(premium.netPremiumAmount.toFixed(2)) || 0;
        setValue(`enrollmentPremiumDtoList.${premium.month - 1}.netPremiumAmount`, premium.netPremiumAmount, {
            shouldDirty: true,
            shouldValidate: true,
        });
        setValue();
    };
};

export default useValidateSubsidyAmount;
